module.exports = __webpack_public_path__ + "/build/web/images/hero-matching-pillows@3x.6dc5721e7f83b49e9366c6d8356a29e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-matching-pillows@3x.jpg
// module id = 141
// module chunks = 13